import { render } from "./FruitShow.vue?vue&type=template&id=457a1dba"
import script from "./FruitShow.vue?vue&type=script&lang=js"
export * from "./FruitShow.vue?vue&type=script&lang=js"
script.render = render

export default script